import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";

import { GenericApiResponseModel, ResponseModel } from "@model/api.model";



@Injectable({
    providedIn: "root",
})
export class InvoiceApiService {

    constructor(
        private http: HttpClient
        ) {
    }
    
    getInvoice(referenceNumber: string): Observable<ResponseModel<GenericApiResponseModel<any>>> {
        return this.http.get<ResponseModel<GenericApiResponseModel<any>>>(
            '/invoice/payment/'+referenceNumber
        );
    }

    getInvoicePayment(txnRefNo: string): Observable<ResponseModel<GenericApiResponseModel<any>>> {
        return this.http.get<ResponseModel<GenericApiResponseModel<any>>>(
            '/invoice/payment/transaction/'+txnRefNo
        );
    }

    
    downloadReceipt(referenceNumber: string,invoiceType: string): Observable<Blob> {
        return this.http.post(
            `/invoice/downloadReceipt/${referenceNumber}/${invoiceType}`, null, { responseType: 'blob' as 'blob' }
        );
    }

}
